import React, {Component} from 'react';
import { Subscribe } from 'unstated';
import DataContainer from './data/data';

class Header extends Component {
    render () {
        return (
            <Subscribe to={[DataContainer]}>
                {(DataContainer) => {
                    return (
                        <div className="header">
                            <h2 style={{margin:'8px'}}>
                                {DataContainer.getGender() === 'mens' ? "Men's" : "Women's"} March Madness 2019 Bracket
                            </h2>
                        </div>
                    );
                }}
            </Subscribe>
        );
    }
}

export default Header;